<template>
    <div class="content">
        <topWell />
        <div class="mainBox">
            <listNav :title="'业务板块'" :navData="classData" @checkPageInd="checkPageInd" />
            <div v-loading="!pageLoding">
                <div class="company" id="company" v-if="classType === '股权投资' || classType === '基金管理'">
                    <div class="tagleft" style="width: 20%">
                        <img src="../../static/icon-gqtz.png" style="height: 80px;" />
                        <img src="../../static/line.png" class="icon-line" />
                        <div class="leftTitle">{{ gqtzData.name }}</div>
                    </div>
                    <div class="tagright" style="width: 80%">
                        <div style="width: calc(100% - 500px);margin-top: -20px;">
                            <div class="numBox">
                                <div class="item">
                                    <div class="num"><span>{{ gqtzData.funds }}</span>支</div>
                                    <div class="tit">在管基金</div>
                                </div>
                                <div class="item">
                                    <div class="num"><span>{{ gqtzData.projects }}</span>个</div>
                                    <div class="tit">投资项目</div>
                                </div>
                                <div class="item">
                                    <div class="num"><span>{{ gqtzData.listedCompany }}</span>家</div>
                                    <div class="tit">上市公司</div>
                                </div>
                            </div>
                            <div class="info" v-html="gqtzData.sketch">
                            </div>
                        </div>
                        <div class="companyImg">
                            <img :src="jjglData.coverOssUrl" class="img" alt="" />
                        </div>
                    </div>
                </div>
                <div class="culture" id="culture" v-if="classType === '股权投资' || classType === '基金管理'">
                    <div class="box">
                        <div class="tagleft" style="width: 20%">
                            <img src="../../static/icon-jjgl.png" style="height: 80px;" />
                            <img src="../../static/line.png" class="icon-line" />
                            <div class="leftTitle">{{ jjglData.name }}</div>
                        </div>
                        <div class="tagright" style="width: 80%">
                            <div style="width: calc(100% - 500px);margin-top: -20px;">
                                <div class="numBox">
                                    <div class="item">
                                        <div class="num"><span>{{ jjglData.funds }}</span>支</div>
                                        <div class="tit">在管基金</div>
                                    </div>
                                    <div class="item">
                                        <div class="num"><span>{{ jjglData.projects }}</span>个</div>
                                        <div class="tit">投资项目</div>
                                    </div>
                                    <div class="item">
                                        <div class="num"><span>{{ jjglData.listedCompany }}</span>家</div>
                                        <div class="tit">上市公司</div>
                                    </div>
                                </div>
                                <div class="info" v-html="jjglData.sketch">
                                </div>
                            </div>
                            <div class="companyImg">
                                <img :src="jjglData.coverOssUrl" class="img" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="businessList" id="businessList" v-if="classType === '产业运营'">
                    <dataNone v-if="businessList.length <= 0"></dataNone>
                    <div class="item" v-for="(v, i) of businessList" :key="i" v-else>
                        <img :src="v.coverOssUrl">
                        <div class="info">
                            <div class="title">{{ v.name }}</div>
                            <div class="tit">{{ v.sketch }}</div>
                        </div>
                    </div>
                </div>
                <div class="newsright" id="newsright" v-if="classType !== '股权投资' && classType !== '基金管理' && classType !== '产业运营'">
                    <div v-if="classType==='投贷联动'">
                        <about :TabData="businessList"/>
                    </div>
                    <template v-else>
                        <dataNone v-if="businessList.length <= 0"></dataNone>
                        <ul class="UL">
                            <li class="li" v-for="item in businessList" :key="item.id" @click="jumpDet(item)">
                                <div class="item-left" v-if="classType!='投贷联动'">
                                    <img :src="item.coverOssUrl" style="width: 100%;height: 100%;">
                                </div>
                                <div class="item-right">
                                    <div class="title">
                                        {{ item.name }}
                                    </div>
                                    <div class="date">
                                        {{ item.createTime ? item.createTime.substring(10, 0) : "" }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="page"
                            style="display: flex; justify-content: center; margin-bottom: 100px;margin-top: 70px;">
                            <pagination v-show="pageInfo.pageTotal > 0" :total="pageInfo.pageTotal"
                                :page.sync="pageInfo.pageNum" :limit.sync="pageInfo.pageSize"
                                @pagination="getBusinessListData" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <bottomNav />
    </div>
</template>

<script>
import topWell from "@/views/topWheel/topWheel.vue";
import bottomNav from "@/views/bottomNav/bottomNav.vue";
import listNav from "../../components/listNav.vue";
import isBuilding from "../../components/isBuilding.vue";
import pagination from "../../components/pagination.vue";
import dataNone from "../../components/dataNone.vue";
import about from "./component/about.vue";

export default {
    components: {
        topWell,
        bottomNav,
        listNav,
        isBuilding,
        pagination,
        dataNone,
        about
    },
    data() {
        return {
            classData: [],
            gqtzData: {},
            jjglData: {},
            businessList: [],
            classType: '',
            classValue: 3,
            pageInfo: {
                pageSize: 10,
                pageNum: 1,
                pageTotal: 2,
            },
            pageLoding: false,
        };
    },
    created() {
        this.getBusinessClassifyData()
        // this.getBusinessData()
        this.getBusinessListData()
    },
    methods: {
        // 跳转文章详情
        jumpDet(v) {
            this.$router.push({
                path: "/articleDet", query: {
                    pageType: 'ywbk',
                    pageName: this.classType,
                    ...v
                }
            });
        },
        scrollToElement(v) {
            // console.log(v, '-----')
            if (v.dictLabel === '股权投资') {
                const element = this.$el.querySelector(`#company`);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
            if (v.dictLabel === '基金管理') {
                const element = this.$el.querySelector(`#culture`);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
            /* if (v.dictLabel === '产业运营') {
                const element = this.$el.querySelector(`#businessList`);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
            if (v.dictLabel === '投贷联动' || v.dictLabel === '重组并购管理') {
                const element = this.$el.querySelector(`#newsright`);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            } */
        },
        // 获取产业运营列表数据
        getBusinessListData() {
            this.businessList = [];
            this.pageLoding = false;
            this.$api.getBusinessList({
                classify: this.classValue,
                ...this.pageInfo
            }).then(res => {
                this.businessList = res.rows
                this.pageInfo.pageTotal = res.total;
                this.pageLoding = true;
            })
        },
        // 获取股权投资 基金管理 数据
        getBusinessData() {
            this.$api.getBusinessList({
                classify: 1
            }).then(res => {
                this.gqtzData = res.rows[0]
            })
            this.$api.getBusinessList({
                classify: 2
            }).then(res => {
                this.jjglData = res.rows[0]
            })
        },
        getBusinessClassifyData() {
            this.$api.getBusinessClassify().then(res => {
                console.log(res, '----zheshisha1')
                this.classData = res.data
                this.classType = res.data.length > 0 ? res.data[0].dictLabel : '股权投资'
            })
        },
        checkPageInd(v) {
            console.log(v);
            this.scrollToElement(v)
            this.classType = v.dictLabel
            this.classValue = v.dictValue
            this.getBusinessListData()
        }
    },
};
</script>
<style scoped lang="less">
.mainBox {
    font-family: "思源黑体";
    box-sizing: border-box;

    .top {
        padding: 0 6.5rem
            /* 104/16 */
        ;
        min-width: 93.75rem
            /* 1500/16 */
        ;
        border-bottom: 1px solid #ececec;
        // padding: 0 200px;
        padding-top: 20px;
        padding-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            display: flex;
            align-items: center;

            .icon-home {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
        }

        .top-right {
            display: flex;
            align-items: center;

            .text {
                width: 104px;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .company {
        margin: 0 auto;
        min-width: 93.75rem
            /* 1500/16 */
        ;
        width: 93.75rem
            /* 1500/16 */
        ;
        padding: 100px 6.5rem;
        padding-right: 5rem;
        display: flex;
        justify-content: space-between;
    }

    .tagright {
        display: flex;
        justify-content: space-between;
    }

    .numBox {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #1e439b;
            font-weight: bold;

            .num {
                font-size: 22px;

                span {
                    font-size: 72px;
                    margin-right: 5px;
                }
            }

            .tit {
                font-size: 16px;
                margin-top: 8px;
            }
        }
    }

    .info {
        margin: 50px 0;
        font-size: 18px;
        font-family: "Microsoft YaHei";
        line-height: 36px;
        padding-left: 10px;
    }

    .companyImg {
        .img {
            width: 480px;
            height: 292px;
        }
    }

    .tagleft {
        img {
            display: block;
        }

        .icon-line {
            width: 89px;
            margin-top: 36px;
            margin-bottom: 30px;
        }

        .leftTitle {
            font-size: 35px;
            font-weight: bold;
        }
    }

    .culture {
        padding: 150px 0;
        background: url("../../static/aboutUsBanner-light.png") no-repeat;
        background-size: cover;
        min-width: 93.75rem
            /* 1500/16 */
        ;

        .box {
            padding: 0 6.5rem
                /* 104/16 */
            ;
            min-width: 93.75rem
                /* 1500/16 */
            ;
            display: flex;
            justify-content: space-between;
            width: 93.75rem
                /* 1500/16 */
            ;
            margin: 0 auto;
        }

        .info {
            .item {
                margin-bottom: 80px;

                &:last-child {
                    margin-bottom: 0;
                }

                .title {
                    color: #1e439b;
                    font-size: 28px;
                    font-weight: bold;
                    margin-bottom: 30px;
                }

                .tit {
                    font-size: 20px;
                    color: #333;
                }
            }
        }
    }
}

.businessList {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0 auto;
    min-width: 93.75rem
        /* 1500/16 */
    ;
    width: 93.75rem
        /* 1500/16 */
    ;
    padding: 0 6.5rem;
    padding-top: 50px;

    .item {
        display: flex;
        margin-bottom: 100px;

        img {
            width: 830px;
            height: 518px;
        }

        .info {
            width: calc(100% - 860px);
            margin-left: 40px;
            margin-top: 0;
        }

        .title {
            font-size: 20px;
            font-weight: bold;
            color: #1E439B;
            margin-bottom: 30px;
        }

        .tit {
            font-size: 18px;
            line-height: 36px;
            color: #666;
        }
    }
}

.newsright {
    margin: 0 auto;
    min-width: 93.75rem
        /* 1500/16 */
    ;
    width: 93.75rem
        /* 1500/16 */
    ;
    padding: 0 6.5rem;
    padding-top: 50px;


    .li {
        border-bottom: 1px solid #ececec;
        padding: 30px 17px;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
            transition: 0.5s;
            background: rgb(244, 245, 250);

            .item-right .title {
                color: #1e439b;
            }
        }

        .item-left {
            width: 320px;

            .img {
                width: 320px;
            }
        }

        .item-right {
            width: calc(100% - 350px);
            margin-left: 30px;

            .title {
                font-size: 20px;
                font-weight: bold;
                color: #333;
                width: 100%;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            .date {
                margin-top: 30px;
                font-size: 18px;
                color: #666;
            }
        }

        .text {
            font-size: 18px;
            color: #333333;
            width: 265px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .time {
            font-size: 18px;
            color: #333333;
        }
    }

}
</style>
